import {
    FETCH_CLIENTS, SET_CLIENT_PAGINATION_DATA,
    TOGGLE_FALSE_LOGGED_CLIENT,
    TOGGLE_TRUE_LOGGED_CLIENT
} from "./types";

const initialState = {
    client: [],
    paginationData: {
        total_pages: 1,
        next: '',
        previous: ''
    },
    isLoggedIn: false
}

export const clientReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CLIENTS:
            return {...state, client: action.payload}
        case TOGGLE_TRUE_LOGGED_CLIENT:
            return {...state, isLoggedIn: true}
        case TOGGLE_FALSE_LOGGED_CLIENT:
            return {...state, isLoggedIn: false}
        case SET_CLIENT_PAGINATION_DATA:
            return {...state, paginationData: {
                    total_pages: action.payload.total_pages,
                    next: action.payload.next,
                    previous: action.payload.previous
                }}
        default: return state
    }
}